module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//gorilla_6_2.png?v=2713d88b";